import styled from 'styled-components';
import IconPlus from '../../../assets/icon-plus-button.svg';

const ButtonPrimary = styled.button`
  display: inline-block;
  position: relative;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 1;
  color: #fff;
  box-shadow: 0 8px 16px rgba(255, 45, 56, 0.32);
  border-radius: 30px;
  padding: 19px 26px;
  border: none;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  text-decoration: none;

  &.nowrap {
    white-space: nowrap;
  }

  &:hover {
    &::before {
      opacity: 0;
    }
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }

  &.ButtonMedium {
    font-size: 14px;
    padding: 16px 26px;
  }

  &.ButtonSmall {
    font-size: 16px;
    font-weight: 500;
    padding: 11px 26px;

    &.ButtonDriver {
      padding: 5px 26px;
    }
  }

  &.disabled {
    background-image: none;
    background-color: #fff;
    box-shadow: none;
    cursor: default;
    border-color: #ededed;
    pointer-events: none;
    opacity: 1;
  }

  &.disabledWithClick {
    background-image: none;
    background-color: #ededed;
    box-shadow: none;
    cursor: pointer;
    border-color: #ededed;
    opacity: 1;
    &::before,
    &::after {
      display: none;
    }
  }

  &.ButtonOk {
    display: block;
    max-width: 170px;
    width: 100%;
  }

  span {
    display: inline-block;
    position: relative;
    z-index: 3;
    text-decoration: none;
    @media (max-width: 599px) {
      line-height: 1.2;
    }
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 30px;
    width: 100%;
    height: 100%;
    content: '';
    background-image: linear-gradient(
      105.63deg,
      #ff2d38 39.07%,
      #f0868c 96.81%
    );
    z-index: 2;
    transition-property: opacity;
    transition-duration: 0.3s;
  }

  &.solid {
    &:hover::before {
      opacity: 1;
    }
    &::before,
    &::after {
      background-image: none;
      background-color: #ff2d38;
    }
  }

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 30px;
    width: 100%;
    height: 100%;
    content: '';
    background-image: linear-gradient(
      105.63deg,
      #ff2d38 39.07%,
      #ff2d38 96.81%
    );
    z-index: 1;
  }

  & > a {
    display: block;
    text-decoration: none;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 1;
    color: #fff;
    width: 100%;
    position: relative;
    z-index: 3;
  }

  &.loadMore {
    display: block;
    width: 300px;
    margin: 40px auto;
  }

  &.saveChanges {
    max-width: 400px;
    width: 100%;
    z-index: 4;
  }

  &.disabled {
    background-image: none;
    background-color: #ededed;
    box-shadow: none;
    cursor: not-allowed;
    pointer-events: none;

    &::before,
    &::after {
      display: none;
    }
  }

  &.widthXlCenter {
    width: calc(100% - 30px);
    @media (max-width: 440px) {
      width: 100%;
    }
  }

  &.w200 {
    max-width: 200px;
    width: 100%;
  }

  &.w280 {
    max-width: 280px;
    width: 100%;
  }

  &.w400 {
    max-width: 400px;
    width: 100%;
  }

  &.w460 {
    max-width: 460px;
    width: 100%;
  }

  &.ButtonXs {
    font-weight: 500;
    font-size: 13px;
    padding: 10px 15px;
  }

  &.ButtonSm {
    font-weight: 500;
    font-size: 14px;
    padding: 11px 19px;
  }

  &.ButtonMd {
    font-weight: 500;
    font-size: 16px;
    padding: 12px 26px;
  }

  &.ButtonMd2 {
    font-size: 14px;
    padding: 16px 26px;
  }

  &.ButtonLg {
    font-size: 18px;
    padding: 16px 26px;
  }

  &.forgot-password {
    width: 45%;
    margin: auto;
  }

  &.ButtonAdd {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 26px;
    min-width: 180px;

    @media (max-width: 1000px) {
      font-size: 14px;
      padding: 10px 34px;
    }

    svg {
      width: 28px;
      height: 26px;
      flex: 0 0 auto;
      margin-right: 6px;
      display: inline-block;
      position: relative;
      z-index: 3;
    }
  }

  &.ButtonDriver {
    display: flex;
    align-items: center;
    padding-top: 9px;
    padding-bottom: 9px;

    svg {
      width: 29px;
      height: 28px;
      flex: 0 0 auto;
      display: inline-block;
      margin-right: 5px;
      position: relative;
      top: -1px;
      z-index: 3;
    }
  }

  &.ButtonSurvey {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13.5px 26px;
    min-width: 186px;

    @media (max-width: 1000px) {
      font-size: 14px;
      padding: 9px 26px;
      min-width: auto;
    }

    svg {
      width: 19px;
      height: 19px;
      flex: 0 0 auto;
      display: inline-block;
      margin-right: 9px;
      position: relative;
      z-index: 3;
    }
  }

  &.ButtonAddFixed {
    @media (max-width: 767px) {
      position: fixed;
      top: 94px;
      right: 20px;
      z-index: 1;
      transition-property: top;
      transition-duration: 0.4s;
    }
    @media (max-width: 599px) {
      position: relative;
      top: 0;
      right: 0;
    }
  }

  &.ButtonPlus {
    padding: 16px 20px;

    span {
      display: flex;
      align-items: center;
      justify-content: center;

      &::before {
        content: '';
        width: 24px;
        height: 24px;
        background-image: url(${IconPlus});
        background-size: contain;
        background-repeat: no-repeat;
        display: inline-block;
        margin-right: 10px;
      }
    }
  }

  &.ButtonBookCall {
    max-width: 240px;
    width: 100%;
  }

  &.ButtonDashboard {
    max-width: 250px;
    width: 100%;
  }

  &.ButtonMenuEditing {
    min-width: 260px;
    max-width: 260px;
  }
  &.ButtonShowOrder {
    min-width: 220px;
    max-width: 220px;
  }

  &.ButtonMin {
    min-width: 120px;
  }

  &.ButtonOrderDetailsMargin {
    max-width: 280px;
    width: 100%;
    margin: 64px auto 0;
    @media (max-width: 1023px) {
      margin: 50px auto 0;
    }
    @media (max-width: 767px) {
      margin: 40px auto 0;
    }
  }

  &.ButtonPublish {
    z-index: 4;
  }

  &.ButtonCloseVideo {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 180px;
    height: 56px;
    margin: -26px 0 0 -90px;
    z-index: 1;
    &:hover {
      &::before {
        opacity: 1;
      }
    }
    @media (max-width: 767px) {
      width: 120px;
      height: 40px;
      font-size: 12px;
      padding: 12px;
      margin: -20px 0 0 -60px;
    }
    @media (max-width: 599px) {
      width: 100px;
      height: 34px;
      font-size: 11px;
      padding: 10px;
      margin: -17px 0 0 -50px;
    }
  }

  &.ButtonMakeRefund {
    margin-top: 50px;
    width: 280px;
    padding: 14px 15px;
    span {
      line-height: 28px;
    }
  }
  &.ButtonInsightsPerformanceSettings {
    font-size: 14px;
    padding: 16px 69px;
  }
  &.ButtonSmallXs {
    font-size: 16px;
    font-weight: 700;
    padding: 15px 40px 15px 30px;

    @media (max-width: 1420px) {
      padding: 15px 40px 15px 30px;
      font-size: 16px;
    }
  }
  .CancellationRefundButton {
    display: flex;
    justify-content: center;
  }
  &.mRight20 {
    margin-right: 20px;
  }
  &.SDConnectProvider {
    font-size: 12px;
    padding: 12px 14px;
  }
`;

export default ButtonPrimary;
